var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasStreamInfo)?_c('div',{attrs:{"id":"img-streaming-wrapper"}},[_c('video-player',{attrs:{"options":_vm.videoOptions}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }